import React, {FC} from "react"

import NoExist from "@irati/ui/src/Layout/NoExist"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"

interface Props extends WithPerkOrReward{}

const InvalidCategory: FC<Props> = ({isRewards, isWallet}) => {
  let linkUrl = "/categories"
  if (isWallet && isRewards) {
    linkUrl = "/flexi-reward/categories"
  }
  return (
    <NoExist
      additionalElement={
        <ButtonRouterLink primary marginTop={7} to={linkUrl}>
          <FormattedMessage id="perks.components.dealList.invalidCategory.returnDeals" />
        </ButtonRouterLink>
      }>
      <FormattedMessage id="perks.components.dealList.invalidCategory.body.pt1" /><br />
      <FormattedMessage id="perks.components.dealList.invalidCategory.body.pt2" />
    </NoExist>
  )
}

export default withPerkOrReward(injectIntl(InvalidCategory))
